import React, { useContext, PropsWithChildren, useCallback } from 'react';
import cn from 'classnames';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import SubmitFormBanner from '../../../common/SubmitFormBanner';
import { SubmitFormContext } from '../../../context';
import { updateMenus } from '@wix/da-editor-tiptap/pkg/redux/actions/editor';
import { useDispatch } from 'react-redux';

import s from './DesktopSubmitLayout.scss';

interface Props {
  preview: React.ReactNode;
  previewClassName?: string;
}

const DesktopSubmitLayout: React.FC<PropsWithChildren<Props>> = ({
  preview,
  previewClassName,
  children,
}) => {
  const { scrollableRef } = useContext(SubmitFormContext)!;
  const dispatch = useDispatch();
  const tellEditorWeScrolled = useCallback(() => {
    dispatch(updateMenus());
  }, [dispatch]);
  return (
    <>
      <SubmitFormBanner />
      <div className={s['root']}>
        <ScrollableContent
          wrapperClassName={s['main']}
          className={s['scrollable']}
          innerRef={el => (scrollableRef.current = el)}
          onScrolled={tellEditorWeScrolled}
        >
          {children}
        </ScrollableContent>
        <div className={cn(s['preview'], previewClassName)}>{preview}</div>
      </div>
    </>
  );
};
DesktopSubmitLayout.displayName = 'DesktopSubmitLayout';

export default DesktopSubmitLayout;
